var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CustomModule, serializeTransaction } from "@ledgerhq/wallet-api-client";
export * from "./types";
// TODO maybe find a better way to type the available custom requests with correct types
export class AcreModule extends CustomModule {
    /**
     * Let the user sign the provided message.
     * @param accountId - Ledger Live id of the account
     * @param message - Message the user should sign
     * @param derivationPath - The derivation path is a relative derivation path from the account
     * e.g to use the first address of an account, one will request for the “0/0“ derivation path
     * @param options - Extra parameters
     *
     * @returns Message signed
     * @throws {@link RpcError} if an error occured on server side
     */
    messageSign(accountId, message, derivationPath, options, meta) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.request("custom.acre.messageSign", {
                accountId,
                message,
                derivationPath,
                options,
                meta,
            });
            return Buffer.from(result.hexSignedMessage, "hex");
        });
    }
    /**
     * Let the user sign a transaction that won't be broadcasted by the connected wallet
     * @param accountId - id of the account
     * @param transaction - The transaction object in the currency family-specific format
     * @param options - Extra parameters
     *
     * @returns The raw signed transaction
     * @throws {@link RpcError} if an error occured on server side
     */
    transactionSign(accountId, transaction, options, meta) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.request("custom.acre.transactionSign", {
                accountId,
                rawTransaction: serializeTransaction(transaction),
                options,
                meta,
            });
            return Buffer.from(result.signedTransactionHex, "hex");
        });
    }
    /**
     * Let the user sign and broadcast a transaction
     * @param accountId - id of the account
     * @param transaction - The transaction object in the currency family-specific format
     * @param options - Extra parameters
     *
     * @returns The transaction hash
     * @throws {@link RpcError} if an error occured on server side
     */
    transactionSignAndBroadcast(accountId, transaction, options, meta) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.request("custom.acre.transactionSignAndBroadcast", {
                accountId,
                rawTransaction: serializeTransaction(transaction),
                options,
                meta,
            });
            return result.transactionHash;
        });
    }
}
//# sourceMappingURL=index.js.map